<template>
  <div class="mt-4">
    <v-card
      v-for="group in groups"
      :key="group.key"
      outlined
      class="mb-3 pa-3"
    >
      <div class="d-flex flex-wrap justify-space-between align-center mb-2">
        <div>
          <div class="font-weight-bold">
            {{ group.meteoTypeName }}
          </div>
          <div class="grey--text text--darken-1">
            {{ group.locations.length }} location - Tipo richiesta {{ group.requestType }}
          </div>
        </div>
        <v-chip
          v-if="group.requestType === 'M'"
          small
          color="grey lighten-3"
        >
          Min. {{ group.effectiveNextBusinessDays }} giorni lavorativi
        </v-chip>
      </div>
      <v-list
        dense
        class="split-location-list mb-3"
      >
        <v-list-item
          v-for="(location, index) in group.locations"
          :key="`${group.key}-${index}`"
          class="px-0"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ location.address }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ formatDate(location.start_date) }} - {{ formatDate(location.end_date) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <ticketing-priority-selection
        v-if="group.requestType === 'M'"
        :required="true"
        :evasion-limit="evasionLimits[group.key] || ''"
        :location-items="group.locations"
        :is-provinciale="isProvinciale"
        :concurrent-request-count="1"
        :next-business-days="group.nextBusinessDays"
        @update-evasion-limit="updateEvasionLimit(group.key, $event)"
        @can-be-moved="updateCanBeMoved(group.key, $event)"
      />
      <v-alert
        v-else
        dense
        text
        type="info"
        color="green"
      >
        Richiesta automatica: la richiesta sarà evasa automaticamente non appena saranno disponibili tutti i dati relativi al periodo richiesto.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment-business-days';

export default {
  components: {
    TicketingPrioritySelection: () => import('@/components/layout/TicketingPrioritySelection')
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    evasionLimits: {
      type: Object,
      default: () => ({})
    },
    canBeMovedMap: {
      type: Object,
      default: () => ({})
    },
    isProvinciale: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateEvasionLimit(key, value) {
      this.$emit('update:evasion-limits', {
        ...this.evasionLimits,
        [key]: value
      });
    },
    updateCanBeMoved(key, value) {
      this.$emit('update:can-be-moved-map', {
        ...this.canBeMovedMap,
        [key]: value
      });
    },
    formatDate(date) {
      return date ? moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '';
    }
  }
};
</script>

<style scoped>
.split-location-list {
  background: transparent;
}
</style>
